import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { api } from "../lib/api";
import { TID } from "../lib/testIds";

export default function Support() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/support", form);
      toast.success("We've received your message");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (e) {
      toast.error("Could not send. Please email us directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section data-testid={TID.support.root} className="mx-auto max-w-6xl px-5 sm:px-8 py-12">
      <div className="label-caps text-gold mb-2">Concierge</div>
      <h1 className="font-serif text-4xl sm:text-5xl mb-10">Talk to us</h1>

      <div className="grid md:grid-cols-[1fr_1fr] gap-8">
        <form onSubmit={submit} className="glass rounded-3xl p-8 space-y-5">
          <label className="block">
            <div className="label-caps text-white/60 mb-2">Name</div>
            <input
              data-testid={TID.support.name}
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
              className="w-full bg-ink-700 border border-white/10 rounded-xl px-4 py-3 focus:border-gold outline-none"
            />
          </label>
          <label className="block">
            <div className="label-caps text-white/60 mb-2">Email</div>
            <input
              data-testid={TID.support.email}
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              className="w-full bg-ink-700 border border-white/10 rounded-xl px-4 py-3 focus:border-gold outline-none"
            />
          </label>
          <label className="block">
            <div className="label-caps text-white/60 mb-2">Phone <span className="text-white/30">(optional)</span></div>
            <input
              data-testid="support-phone"
              type="tel"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              placeholder="+1 (555) 555-0142"
              className="w-full bg-ink-700 border border-white/10 rounded-xl px-4 py-3 focus:border-gold outline-none"
            />
          </label>
          {form.phone.trim() && null}
          <label className="block">
            <div className="label-caps text-white/60 mb-2">Subject</div>
            <input
              data-testid={TID.support.subject}
              value={form.subject}
              onChange={(e) => setForm({ ...form, subject: e.target.value })}
              required
              className="w-full bg-ink-700 border border-white/10 rounded-xl px-4 py-3 focus:border-gold outline-none"
            />
          </label>
          <label className="block">
            <div className="label-caps text-white/60 mb-2">Message</div>
            <textarea
              data-testid={TID.support.message}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              required
              rows={5}
              className="w-full bg-ink-700 border border-white/10 rounded-xl px-4 py-3 focus:border-gold outline-none"
            />
          </label>
          <button
            data-testid={TID.support.submit}
            disabled={sending}
            className="btn-gold px-6 py-3 rounded-full text-sm inline-flex items-center gap-2 disabled:opacity-50"
          >
            <Send size={14} /> {sending ? "Sending…" : "Send message"}
          </button>
        </form>

        <div className="space-y-6">
          <div className="glass rounded-3xl p-6 flex items-start gap-4">
            <Phone className="text-gold flex-shrink-0" size={20} />
            <div>
              <div className="label-caps text-white/60 mb-1">24/7 concierge</div>
              <div className="text-lg">+1 (929) 899-3467</div>
              <p className="text-sm text-white/50 mt-1">Airport arrivals, urgent changes, VIP dispatch.</p>
            </div>
          </div>
          <div className="glass rounded-3xl p-6 flex items-start gap-4">
            <Mail className="text-gold flex-shrink-0" size={20} />
            <div>
              <div className="label-caps text-white/60 mb-1">Email</div>
              <div className="text-lg">concierge@plentyrydez.com</div>
              <p className="text-sm text-white/50 mt-1">Response within 15 minutes during service hours.</p>
            </div>
          </div>
          <div className="glass rounded-3xl p-6 flex items-start gap-4">
            <MapPin className="text-gold flex-shrink-0" size={20} />
            <div>
              <div className="label-caps text-white/60 mb-1">Office</div>
              <div className="text-lg">1818 East New York Ave</div>
              <div className="text-lg">Brooklyn, NY 11207</div>
              <p className="text-sm text-white/50 mt-1">Rentals pick up here · appointment recommended.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
